import React from 'react';
import {List, ListItem} from '@material-ui/core';
import PropTypes, {InferType} from 'prop-types';
import {Generate} from 'commons/utils/Functions';
import {ModuleItem} from 'commons/types/Types';
import {ModuleShape} from 'commons/shapes/flow/Flow';
import MenuItem from 'layouts/commons/sidebar/menu-item/MenuItem';
import {findSubModule} from '../utils/Utils';

function Menu(props: InferType<typeof Menu.propTypes>) {
    const {menuItems, active, handleClick} = props;

    return (
        <List component='nav'>
            {menuItems &&
                menuItems.map((item: ModuleItem, index: number) => {
                    let flag: boolean = `${item.viewId}` == active;
                    if (!flag && item.items && item.items.length) {
                        flag = findSubModule(item.items, active);
                    }
                    return (
                        item &&
                        item.showMenu && (
                            <ListItem
                                component={'div'}
                                disableGutters
                                onClick={(event: React.SyntheticEvent) => {
                                    event.stopPropagation();
                                    handleClick(item, false);
                                }}
                                key={Generate.uniqueID(index)}>
                                <MenuItem
                                    module={item}
                                    active={active}
                                    open={flag}
                                    handleChildClick={handleClick}
                                />
                            </ListItem>
                        )
                    );
                })}
        </List>
    );
}

Menu.propTypes = {
    menuItems: PropTypes.arrayOf(ModuleShape).isRequired,
    active: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
};

export default Menu;
